import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { updateIngredientInDb } from 'store/localDb';
import { getCurrentUserId, updateIngredient } from 'store/storeValtio';
import NumberPadModal from '../../common/NumberPadModal';
import { formatDisplayName, getIngredient } from 'helpers/ingredientHelpers';
import Select from '../../common/Select';

export default function EditIngredient(props) {
    const [submitting, setSubmitting] = useState(false);
    const [doseVal, setDoseVal] = useState('1.0');
    const [doseUnit, setDoseUnit] = useState('mg');
    const [popup, setPopup] = useState({
      show: false,
    });

    const navigate = useNavigate();
    const params = useParams();
    const iId = Number(params.id);
    const ing = getIngredient(iId);
    const currentUserId = getCurrentUserId();

    useEffect(() => {

      setDoseVal(ing.quantity.toString());
      setDoseUnit(ing.unit);

    }, [])
    
    
    console.log('EditIngredient', iId, ing);

    const options = [
      'mcg', 'mg', 'ml', 'l'
    ];
    const defaultOption = options[1];
  
    function doseUnitChanged(e) {
      console.log('doseUnit', e.value);
      setDoseUnit(e.value);
    }
  
    function openNumberPad() {
      setPopup({show: true});
    }
  
    function setDose(d) {
      console.log('setDose', d);
      setDoseVal(d);
      setPopup({show: false});
    }
  
    function cancelDose() {
      console.log('cancelDose');
      setPopup({show: false});
    }

    function update() {
      handleUpdateIngredient();
    }

    async function handleUpdateIngredient() {
      console.log('handleUpdateIngredient');
      setPopup({show: false});
      setSubmitting(true);

      const updateVals ={
        id: ing.id,
        userId: currentUserId,
        medicationId: ing.medicationId,
        DsldId: ing.DsldId,
        quantity: Number(doseVal),
        unit: doseUnit
      }
  
      console.log('updateIngredient', updateVals);
      await updateIngredientInDb(updateVals);
      updateIngredient(updateVals);
      setSubmitting(false);
      navigate('/ingredients/'+ ing.medicationId);  // do this to refresh
    }
  
    function cancelEdit() {
      console.log('cancelEdit');
      setPopup({show: false});
      navigate(-1);
    }

    const dn = formatDisplayName(ing);

    return (
      <div className='mcard'>
        <div className='mcard-screen flex flex-col justify-center'>
          <div>Edit ingredient</div>
          <div>{dn}</div>
        </div>
        <div className='flex flex-row justify-center mt-10 text-2xl font-bold'>
          <NumberPadModal
              open={popup.show} 
              initialValue={doseVal}
              onConfirm={(v)=>setDose(v)}
              onCancel={()=>cancelDose()}
              />

          <div
            className="w-4/12 border-2 border-black p-2 hover:cursor-pointer"
            onClick={()=>openNumberPad()}>{doseVal}
          </div>
          <Select
              className="w-4/12 border-2 border-black hover:cursor-pointer"
              options={options} 
              onChange={(e)=>doseUnitChanged(e)} 
              defaultOption={defaultOption} 
              placeholder="Select a dose unit" />
        </div>
        <div className='flex justify-around mt-10 pb-1 text-2xl'>
          <button 
            onClick={()=>cancelEdit()} 
            className='mbtn w-5/12 mr-2 bg-red-400'>
              Cancel
          </button>
          <button 
            onClick={()=>update()} 
            disabled={submitting}
            className='mbtn w-5/12 bg-green-400'>
              Update Ingredient
          </button>
        </div>
      </div>
    )
}

